import Alert from "@mui/material/Alert";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { ChooserCard } from "../components/chooser-card.component";
import { NoticeBox } from "../components/notice-box.component";
import { getTargetGroups } from "../config/targets.config";

interface IChooserPageProps {
  showMovedNotice?: boolean;
}

export const ChooserPage = ({ showMovedNotice = false }: IChooserPageProps) => (
  <Stack spacing={4}>
    {showMovedNotice && (
      <Alert severity="info">
        Das GRS Portal ist umgezogen. Die aufgerufene Seite gibt es hier nicht mehr — bitte wählen Sie unten den
        passenden Bereich.
      </Alert>
    )}
    <Typography variant="h1">Willkommen bei der GRS</Typography>
    <Typography variant="body1">Bitte wählen Sie einen Bereich</Typography>
    {getTargetGroups().map((group) => (
      <Stack key={group.id} spacing={2}>
        <Typography variant="h5" component="h2">
          {group.title}
        </Typography>
        {group.notice !== "" && <NoticeBox text={group.notice} />}
        <Grid container spacing={3} alignItems="stretch">
          {group.targets.map((target) => (
            <Grid key={target.id} item xs={12} md={4}>
              <ChooserCard target={target} />
            </Grid>
          ))}
        </Grid>
      </Stack>
    ))}
  </Stack>
);
